import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'atw-block-header-admin',
  templateUrl: './block-header-admin.component.html',
  styleUrls: ['./block-header-admin.component.scss']
})
export class AtwBlockHeaderAdmin implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
